export const ID_PREFIX = 'ID_';
export const DEFAULT_OUTPUT_VALUE_PRECISION = 2;
export const DEFAULT_CURRENCY = 'GBP';
export const ERRONEOUS_VALUE = '---';
export const CALCULATOR_CREATOR_FORMULAS_PATH = 'dpwstools';
